import * as GetProjectInvestedTypes from 'src/actions/project/investment/get/Types';
import {
  GetProjectInvestedAction,
  GetProjectInvestedSuccess
} from 'src/actions/project/investment/get/GetProjectInvested.actions';
import Person from 'src/entities/Person';

export interface GetProjectInvestedState {
  projectInvested?: Person[];
  investedUser?: boolean;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetProjectInvestedState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetProjectInvestedReducer(
  state: GetProjectInvestedState = initialState,
  action: GetProjectInvestedAction
): GetProjectInvestedState {

  switch (action.type) {
    case GetProjectInvestedTypes.GET_PROJECT_INVESTED_ATTEMPT:
      return {...state, projectInvested: undefined, loading: true, error: false};
    case GetProjectInvestedTypes.GET_PROJECT_INVESTED_SUCCESS:
      const projectInvested: Person[] = (action as GetProjectInvestedSuccess).payload.projectInvested;
      const investedUser: boolean = (action as GetProjectInvestedSuccess).payload.userInvested;
      return {
        ...state,
        projectInvested: projectInvested,
        loading: false,
        error: false,
        investedUser: investedUser,
      };
    case GetProjectInvestedTypes.GET_PROJECT_INVESTED_FAILURE:
      return {...state, projectInvested: undefined, loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/investment/GetProjectInvestedReducer.tsx